import { components, MultiValueProps } from 'react-select';
import { SortableElement } from 'react-sortable-hoc';

import { Option } from '../../../types/Option';
import { Chip } from '../../Chip/Chip';
import { onSortableElementMouseDown } from '../sortable-utils';
import { resetGetStyles } from './resetGetStyles';

const SortableMultiValue = SortableElement(components.MultiValue);

export const MultiValue = (props: MultiValueProps<Option>) => {
  const { children, removeProps, selectProps } = props;
  const { enableValueContainer, isDisabled, enableSorting } = selectProps;
  const sortableIndex = (props as MultiValueProps<Option> & { index?: number })
    .index;

  if (!enableValueContainer) {
    return null;
  }

  const isSortable =
    !!enableSorting && typeof sortableIndex === 'number' && sortableIndex >= 0;

  const innerProps = isSortable
    ? {
        ...props.innerProps,
        onMouseDown: onSortableElementMouseDown,
      }
    : props.innerProps;

  const MultiValueComponent = isSortable
    ? SortableMultiValue
    : components.MultiValue;

  const sortableProps = isSortable ? { index: sortableIndex } : {};

  return (
    // @ts-ignore `react-select`'s official suggestion explicitly ignores this error since it does not pass `index` to `react-sortable-hoc` (see https://react-select.com/advanced#sortable-multiselect)
    <MultiValueComponent
      {...props}
      {...sortableProps}
      innerProps={innerProps}
      getStyles={resetGetStyles}
    >
      <Chip
        preset={isDisabled ? undefined : 'removable'}
        text={children as string}
        onRemove={() => removeProps.onClick(null)}
      />
    </MultiValueComponent>
  );
};
